/**
 * List pattern constants and types.
 * See LIST_PATTERNS.md for architecture docs and how to add new patterns.
 */

// ---------------------------------------------------------------------------
// Ordered list patterns
// ---------------------------------------------------------------------------

export const OL_PATTERNS = ['decimal-chain', 'structured', 'roman-chain'] as const;
export type TOlPattern = (typeof OL_PATTERNS)[number];
export const DEFAULT_OL_PATTERN: TOlPattern = 'decimal-chain';

/** Preview levels shown as indented lines in the toolbar dropdown */
export const OL_PATTERN_PREVIEW: Record<TOlPattern, [string, string, string]> = {
  'decimal-chain': ['1.', '1.1.', '1.1.1.'],
  structured: ['a)', 'i)', '1)'],
  'roman-chain': ['I.', 'I.I.', 'I.I.I.'],
};

// ---------------------------------------------------------------------------
// Unordered list patterns
// ---------------------------------------------------------------------------

export const UL_PATTERNS = ['bullet', 'dash'] as const;
export type TUlPattern = (typeof UL_PATTERNS)[number];
export const DEFAULT_UL_PATTERN: TUlPattern = 'bullet';

/** Preview markers shown in the toolbar dropdown */
export const UL_PATTERN_PREVIEW: Record<TUlPattern, [string, string]> = {
  bullet: ['•', '◦'],
  dash: ['–', '◦'],
};
